import React from "react";
import { Form, Input } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "../../../../assets/scss/profile/Profile.module.scss";
import { createDuplicateIbanValidator, createIbanValidator } from "../utils/ibanValidation";

interface IBANFormFieldProps {
  form: any;
  ibanFieldName: string;
  titleFieldName: string;
  ibanPlaceholder: string;
  titlePlaceholder: string;
  isRequired?: boolean;
  className?: string;
}

export const IBANFormField: React.FC<IBANFormFieldProps> = ({
  form,
  ibanFieldName,
  titleFieldName,
  ibanPlaceholder,
  titlePlaceholder,
  isRequired = false,
  className = "",
}) => {
  const { t } = useAppTranslation();

  const ibanRules = [
    ...(isRequired ? [{ required: true, message: t("profile.bank.ibanRequired") }] : []),
    {
      validator: createIbanValidator(t),
    },
    {
      validator: createDuplicateIbanValidator(form, ibanFieldName, t),
    },
  ];

  const titleRules = isRequired ? [{ required: true, message: t("profile.bank.titleRequired") }] : [];

  return (
    <div
      className={`tw-inline-flex tw-flex-col-reverse tw-items-start tw-justify-start tw-gap-2 tw-self-stretch md:tw-flex-row md:tw-gap-1 ${className}`}
    >
      <Form.Item name={ibanFieldName} className="tw-mb-0 tw-w-full tw-flex-1" rules={ibanRules}>
        <Input
          size="large"
          className={`${styles.inputLtr}`}
          placeholder={ibanPlaceholder}
          suffix="IR"
          onlyNumbers
          canStartWithZero
        />
      </Form.Item>
      <div className="tw-inline-flex tw-w-full tw-flex-1 tw-flex-col-reverse tw-justify-start tw-gap-8 md:tw-max-w-32 md:tw-flex-row">
        <Form.Item name={titleFieldName} className="tw-mb-0 tw-w-full tw-self-stretch" rules={titleRules}>
          <Input size="large" placeholder={titlePlaceholder} />
        </Form.Item>
      </div>
    </div>
  );
};
